<template>
  <mdb-container>
    <div class="gp-has-header" v-if="loggedIn && isTranslator">
      <mdb-card class="text-left mb-4">
        <mdb-card-header class="secondary-color">
          <h3>Language Upload/Download</h3>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-icon icon="language"/>
          <select v-model="selectedLang">
            <option v-for="l in availableLanguages" :key="l.language" :value="l.value">{{ l.label }}</option>
          </select>
          <div>
            <mdb-btn size="sm" @click="download" icon="download">Download</mdb-btn>
            <mdb-btn size="sm" @click="upload" icon="upload">Upload</mdb-btn>
          </div>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="text-left mb-4" v-if="errors.length > 0">
        <mdb-card-header class="danger-color text-white">
          <h3>File Upload Errors</h3>
        </mdb-card-header>
        <mdb-card-body>
          <div v-for="err in errors">
            {{err}}
          </div>
        </mdb-card-body>
      </mdb-card>
      <mdb-modal v-if="uploadModal" @close="uploadModal = false">
        <mdb-modal-header class="secondary-color">
          <h5>Upload File</h5>
        </mdb-modal-header>
        <mdb-modal-body class="text-left">
          <mdb-file-input v-on:getValue="doUpload"/>
        </mdb-modal-body>
      </mdb-modal>
    </div>
  </mdb-container>
</template>

<script>

import TranslateSection from "../common/TranslateSection";
import Security from "../../services/security";
import download from "js-file-download";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";

export default {
  name: 'translate-common-buttons',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbFileInput,
    TranslateSection
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    settings() {
      return this.$store.state.settings
    },
    isTranslator() {
      return Security.isTranslator()
    }
  },
  watch: {
    settings(n, o) {
      this.setLanguages()
    },
  },
  data() {
    return {
      selectedLang: "en",
      availableLanguages: [],
      uploadModal: false,
      errors: []

    }
  },
  mounted() {
    document.title = "Language Upload/Download"
    if (this.settings) this.setLanguages()
  },
  methods: {
    setLanguages() {
      if (this.settings.languages) {
        for (let l of this.settings.languages) {
          this.availableLanguages.push({value: l.language, label: l.nativeName})
        }
      }
    },
    upload() {
      this.uploadModal = true
    },
    doUpload(file) {
      this.uploadModal = false
      this.$store.dispatch("setExecuting", true)
      let url = "/admin/langUpload/" + this.selectedLang
      api.postFile(url, file[0]).then(
        () => {
          this.$notify.success({message: "File processed successfully.", timeOut: 5000})
        },
        (error) => {
          this.errors = error.response.data
          this.$notify.warn({message: "File processed with errors.", timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    download() {
      this.$store.dispatch("setExecuting", true)
      api.getBlob("/admin/langDownload/" + this.selectedLang).then(
        (res) => {
          let filename = "translate.csv"
          let cd = res.headers["content-disposition"]
          console.log("Disposition is ", cd)
          if (cd) {
            let parts = cd.split(';')
            console.log("Parts ", parts)
            if (parts.length > 0) {
              let parts2 = parts[1].split("=")
              if (parts2.length > 0) filename = parts2[1]
            }
          }
          download(res.data, filename)
        },
        (error) => {
          this.$notify.error({message: "Could not retrieve file - " + error.response.status, timeOut: 4000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>

